import { z } from "zod";

export const schema = z.object({
    name: z.string().min(1, "forms.general-validation.name_required"),
    type: z.string() as any,
    value: z.string().nullable(),
    description: z.string().nullable(),
});

export type OfferCustomFieldData = z.infer<typeof schema>;
